<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->

        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div v-if="initialLoading" class="text-center py-10">
          <b-spinner variant="primary" label="Loading contribution form"></b-spinner>
          <div class="mt-3">Loading contribution form...</div>
        </div>
        <div v-show="!initialLoading" class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <b-alert v-if="paymentError" variant="danger" show>
            {{ paymentError }}
          </b-alert>
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <form class="form" id="kt_form" @submit.prevent="handleForm">
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    {{ panelItems.detailsContribution }}
                  </h4>
                  <div class="form-group">
                    <!-- <label
                      >{{ panelItems.projectName
                      }}<span class="star">*</span></label
                    >
                    <b-form-select
                      v-model="form.projectName"
                      :options="projects"
                      class="mb-3"
                    ></b-form-select>
                    <span class="form-text text-muted">{{
                      panelItems.selectProj
                    }}</span> --> 
                    <div v-for="(item,index) in projects" :key="index">
                    <input type="radio" v-model="form.projectName" name="projectName" :value="item"/> {{item}}
                    </div>
                  </div>
                  <b-form-group>
                    <label
                      >{{ panelItems.amount }}<span class="star">*</span></label
                    >
                    <b-form-input
                      type="text"
                      class="form-control form-control-solid form-control-lg"
                      v-model="form.amount"
                      placeholder="Amount"
                      :state="validateState('amount')"
                      aria-describedby="input-amount"
                    ></b-form-input>
                    <span class="form-text text-muted">{{
                      panelItems.contributionAmount
                    }}</span>
                    <b-form-invalid-feedback id="input-amount">
                      <p v-if="!$v.form.amount.required">Amount is required.</p>
                      <p
                        v-if="
                          !$v.form.amount.integer && $v.form.amount.required
                        "
                      >
                        Enter valid amount(in numbers only).
                      </p>
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <!--end: Wizard Step 1-->

                <!--begin: Wizard Step 2-->
                <div class="pb-5" data-wizard-type="step-content">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    {{ panelItems.enterPersDetails }}
                  </h4>
                  <div class="row">
                    <div class="col-xl-6">
                      <b-form-group>
                        <label
                          >{{ panelItems.fullName
                          }}<span class="star">*</span></label
                        >
                        <b-form-input
                          type="text"
                          class="
                            form-control form-control-solid form-control-lg
                          "
                          id="fullName"
                          v-model="form.donorName"
                          placeholder="Full Name"
                          :state="validateState('donorName')"
                          aria-describedby="input-fullName"
                        ></b-form-input>
                        <span class="form-text text-muted">{{
                          panelItems.enterFullName
                        }}</span>
                        <b-form-invalid-feedback id="input-fullName">
                          <p v-if="!$v.form.donorName.required">
                            Full name is required.
                          </p>
                          <p
                            v-if="
                              !$v.form.donorName.alpha &&
                              $v.form.donorName.required
                            "
                          >
                            Enter valid name.
                          </p>
                          <p
                            v-if="
                              !$v.form.donorName.minLength &&
                              $v.form.donorName.required
                            "
                          >
                            Enter minimum 3 characters.
                          </p>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-xl-6">
                      <b-form-group>
                        <label
                          >{{ panelItems.address
                          }}<span class="star">*</span></label
                        >
                        <b-form-textarea
                          id="address"
                          v-model="form.address"
                          placeholder="Address"
                          :state="validateState('address')"
                          aria-describedby="input-address"
                        ></b-form-textarea>
                        <span class="form-text text-muted">{{
                          panelItems.enterAddress
                        }}</span>
                        <b-form-invalid-feedback id="input-address">
                          <p v-if="!$v.form.donorName.required">
                            Address is required.
                          </p>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <b-form-group>
                        <label
                          >{{ panelItems.city
                          }}<span class="star">*</span></label
                        >
                        <b-form-input
                          type="text"
                          class="
                            form-control form-control-solid form-control-lg
                          "
                          id="city"
                          v-model="form.city"
                          placeholder="City"
                          :state="validateState('city')"
                          aria-describedby="input-city"
                        ></b-form-input>
                        <span class="form-text text-muted">{{
                          panelItems.enterCity
                        }}</span>
                        <b-form-invalid-feedback id="input-city">
                          <p v-if="!$v.form.city.required">City is required.</p>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-xl-6">
                      <b-form-group>
                        <label>{{ panelItems.postCode }}</label>
                        <b-form-input
                          type="text"
                          class="
                            form-control form-control-solid form-control-lg
                          "
                          id="postCode"
                          v-model="form.postalCode"
                          placeholder="Postal Code"
                          :state="validateState('postalCode')"
                          aria-describedby="input-postalCode"
                        ></b-form-input>
                        <span class="form-text text-muted">{{
                          panelItems.enterPostCode
                        }}</span>
                        <b-form-invalid-feedback id="input-postalCode">
                          <p v-if="!$v.form.postalCode.integer">
                            Enter valid Postal Code (Numbers only).
                          </p>
                          <p v-if="!$v.form.postalCode.maxLength">
                            Enter valid Postal Code(Cannot exceed 6 digits).
                          </p>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <b-form-group>
                        <label
                          >{{ panelItems.country
                          }}<span class="star">*</span></label
                        >
                        <b-form-input
                          type="text"
                          :readonly="true"
                          class="
                            form-control form-control-solid form-control-lg
                          "
                          id="country"
                          v-model="form.country"
                        >
                        </b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-xl-6">
                      <b-form-group>
                        <label
                          >{{ panelItems.mobileNum
                          }}<span class="star">*</span></label
                        >
                        <b-form-input
                          type="tel"
                          class="
                            form-control form-control-solid form-control-lg
                          "
                          v-model="form.phone"
                          id="phone"
                          placeholder="Mobile Number"
                          :state="validateState('phone')"
                          aria-describedby="input-phone"
                        ></b-form-input>
                        <span class="form-text text-muted">{{
                          panelItems.enterMobileNum
                        }}</span>
                        <b-form-invalid-feedback id="input-phone">
                          <p v-if="!$v.form.phone.required">
                            Mobile number is required.
                          </p>
                          <p
                            v-if="
                              !$v.form.phone.integer && $v.form.phone.required
                            "
                          >
                            Mobile number is not valid(Numbers only).
                          </p>
                          <p
                            v-if="
                              !$v.form.phone.minLength && $v.form.phone.required
                            "
                          >
                            Mobile number is not valid.
                          </p>
                          <p
                            v-if="
                              !$v.form.phone.maxLength && $v.form.phone.required
                            "
                          >
                            Mobile number is not valid.
                          </p>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-xl-6">
                      <b-form-group>
                        <label
                          >{{ panelItems.email
                          }}<span class="star">*</span></label
                        >
                        <b-form-input
                          type="email"
                          class="
                            form-control form-control-solid form-control-lg
                          "
                          v-model="form.email"
                          id="email"
                          placeholder="Email"
                          :state="validateState('email')"
                          aria-describedby="input-email"
                        ></b-form-input>
                        <span class="form-text text-muted">{{
                          panelItems.enterEmail
                        }}</span>
                        <b-form-invalid-feedback id="input-email">
                          <p v-if="!$v.form.email.required">
                            Email address is required.
                          </p>
                          <p
                            v-if="
                            !$v.form.email.email && $v.form.email.required
                            "
                          >
                            Email addtess is not valid.
                          </p>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-xl-6">
                      <label>{{ panelItems.paymentGateway }}</label>
                      <b-form-select
                        v-model="form.paymentGateway"
                        :options="paymentGatewaylist"
                        class="mb-3"
                        :disabled="paymentGatewayLoading"
                      ></b-form-select>
                      <span v-if="paymentGatewayLoading" class="form-text text-muted">Loading payment methods...</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="text-center">
                    <b-form-group>
                      <input
                        type="checkbox"
                        id="checkbox"
                        v-model="check"
                        name="checkbox"
                        aria-describedby="input-check"
                        v-on:change="termschecked"
                      />
                      I agree to
                      <a style="color: blue" v-b-modal.modal-1>{{
                        panelItems.contTerms
                      }}</a>

                      <div>
                        <b-modal id="modal-1" title="Contribution Terms">
                          <p class="my-4">{{ termsData }}</p>
                        </b-modal>
                      </div>
                      <div style="color: red" v-if="checked == false">
                        <p>{{ panelItems.agreeContTerms }}</p>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <!--end: Wizard Step 2-->

                <!--begin: Wizard Actions -->
                <div class="d-flex justify-content-center border-top pt-10">
                  <!-- <div class="mr-2"></div> -->
                  <!-- <div class="mt-0"> -->
                  <!-- <button v-on:click="submit" ref="kt_login_signin_submit"
                      class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3">
                      Proceed to Payment
                    </button> -->
                  <div class="text-center">
                    <button
                      class="
                        btn btn-primary
                        font-weight-bold
                        px-9
                        py-4
                        my-3
                        font-size-3
                      "
                      ref="kt_login_signin_submit"
                      :loading="loading"
                      :disabled="loading"
                      color="info"
                      v-on:click="submit"
                    >
                      <span v-if="loading">Processing...</span>
                      <span v-else>Proceed to Payment</span>
                    </button>
                  </div>
                  <!-- </div> -->
                </div>
                <!--end: Wizard Actions -->
              </form>
            </div>
            <!--end: Wizard Form-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import ApiService from "@/core/services/api.service";
import { API_ENDPOINTS } from "@/core/services/api.endpoints";
import { validationMixin } from "vuelidate";
import {
  required,
  integer,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  name: "contribute",
  data() {
    return {
      loading: false,
      paymentError: "",
      initialLoading: true,
      form: {
        projectId: "1",
        projectName: "",
        amount: "",
        donorName: "",
        address: "",
        city: "",
        postalCode: "",
        country: "India",
        phone: "",
        email: "",
        indianPassport: "Yes",
        projectDescription: "",
        paymentGateway: "",
      },
      check: false,
      checked: true,
      panelItems: [],
      params: [],
      projects: [],
      termsData: "",
      paymentGatewaylist: [],
      paymentGatewaylistdata: null,
      paymentGatewayLoading: false,
    };
  },
  created: function () {
    Promise.all([
      this.getPageContents(),
      this.alertMessage(),
      this.getProjectDetails(),
    ]).finally(() => {
      this.initialLoading = false;
    });
  },
  validations: {
    form: {
      amount: {
        required,
        integer,
      },
      donorName: {
        required,
        minLength: minLength(3),
      },
      address: {
        required,
      },
      city: {
        required,
      },
      postalCode: {
        integer,
        maxLength: maxLength(6),
      },
      phone: {
        required,
        integer,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      email: {
        required,
        email,
      },
    },
  },
  watch: {
    "form.projectName"() {
      const id = this.projects.indexOf(this.form.projectName);
      this.paymentGatewaylist = [];
      this.paymentGatewayLoading = true;
      ApiService.query(API_ENDPOINTS.projects.activatedPaymentGateway(id + 1)).then(({ data }) => {
        const result = data.paymentGateway;
        this.paymentGatewaylistdata = JSON.parse(JSON.stringify(result));
        result.forEach((element) => {
          this.paymentGatewaylist.push(element.pg_name);
        });
        this.form.paymentGateway = this.paymentGatewaylist[0] || "";
      }).catch(() => {
        this.paymentGatewaylistdata = null;
      }).finally(() => {
        this.paymentGatewayLoading = false;
      });
    },
  },
  mounted() {},
  methods: {
    handleForm() {},
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getPageContents() {
      return ApiService.query(API_ENDPOINTS.organisation.details).then(({ data }) => {
        this.panelItems = data["panelItems"];
        localStorage.setItem("PanelItems", JSON.stringify(this.panelItems));
      });
    },
    getProjectDetails() {
      return ApiService.query(API_ENDPOINTS.projects.forDonation).then(({ data }) => {
        const result = data.projectDetails;
        result.forEach((element) => {
          this.projects.push(element.project_name);
        });
        this.form.projectName = this.projects[0] || "";
        //this.projects = data;
        //this.json_data = this.projects.projectDetails;
        //localStorage.setItem("projectItems", JSON.stringify(this.panelItems));
      });
    },
    alertMessage() {
      return ApiService.query(API_ENDPOINTS.organisation.terms).then(({ data }) => {
        let termsContent = data;
        this.termsData = termsContent.termsData;
      });
    },
    termschecked() {
      if (this.check == false) {
        this.checked = false;
        return;
      } else {
        this.checked = true;
      }
    },
    submit() {
      if (this.loading) {
        return;
      }
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      if (this.check == false) {
        this.checked = false;
        return;
      }

      // set spinner to submit button only after validation succeeds
      this.paymentError = "";
      this.loading = true;
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.paymentGatewaylistdata.forEach((item) => {
        const data = JSON.parse(JSON.stringify(item));
        if (data.pg_name === this.form.paymentGateway) {
          localStorage.setItem("activatedPgId", data.activatedPGId.toString());
          this.form.activatedPgId = data.activatedPGId.toString();
          //console.log(this.form.activatedPgId);
        }
      });

      ApiService.post(API_ENDPOINTS.donations.create, this.form).then(({ data }) => {
        this.params["order_id"] = data["donation"]["donationId"];
        this.params["amount"] = this.form.amount;
        //this.params["return_url"] = "http://localhost:8080/#/response-handler";
        this.params["customer_id"] = data["donation"]["donorId"];
        this.params["customer_email"] = this.form.email;
        this.params["customer_phone"] = this.form.phone;
        this.params["description"] = this.form.projectDescription;
        this.params["billing_address_first_name"] = this.form.donorName;
        this.params["billing_address_line1"] = this.form.address;
        this.params["billing_address_city"] = this.form.city;
        this.params["billing_address_country"] = this.form.country;
        this.params["billing_address_postal_code"] = this.form.postalCode;
        this.params["product_id"] = this.form.projectId;
        this.params["udf1"] = this.form.projectName;
        // let body = `order_id=${this.params["order_id"]}&amount=${this.params["amount"]}&customer_id=${this.params["customer_id"]}&product_id=${this.params["product_id"]}`;
        return ApiService.post(API_ENDPOINTS.payment.create, data["donation"]).then(({ data }) => {
          if (data && data.error) {
            throw new Error(
              `Payment failed: ${
                data.error.description || "Payment request failed"
              }. Please try again.`
            );
          }
          if (!data || !data.short_url) {
            throw new Error("Payment request failed. Please try again.");
          }
          let links;
          links = data;
          this.webUrl = links.short_url;
          this.loading = false;
          submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
          window.open(this.webUrl, "_self");
        });
      }).catch((error) => {
        this.loading = false;
        submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
        this.paymentError =
          error && error.message && error.message !== "Network Error"
            ? error.message
            : "Payment request failed. Please try again.";
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
};
</script>
